import React from 'react';
import BookingDetails from './BookingDetails';

/**
 * BookingSidebar - Desktop sticky sidebar showing order summary
 * Wrapper around BookingDetails component with sidebar variant
 */
const BookingSidebar = (props) => {
  return (
    <div className="wizard-sidebar">
      <div className="wizard-sidebar-content">
        <BookingDetails {...props} variant="sidebar" />
      </div>
    </div>
  );
};

export default BookingSidebar;
